/*
 *  This file hrone-network.interceptor.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 20203
 *  (C) 2015-20203. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HroneNetworkInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipWithCredentials = request.headers.get('skip-withcredentials') === 'true';
    const clonedRequest = request.clone({
      withCredentials: !skipWithCredentials,
      setHeaders: {
        'X-Requested-With': window.location.origin
      },
      headers: request.headers.delete('skip-withcredentials')
    });

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (request.headers.get('hrone-refresh-header')) {
          if (error.status === 503) return throwError(error)
          const newError = { ...error };
          newError.status = 5999;
          return throwError(newError);
        }
        return throwError(error);
      },)
    );
  }
}